import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./LearningLounge.scss";
import MarqueeText from "./MarqueeText";
import QuickLinksCard from "./QuickLinksCard";
import ProgramsAvailable from "./ProgramsAvailable";
import Gallery from "./Gallery";
import KnowledgeNuggets from "./KnowledgeNuggets";
import VideoContainer from "./VideoContainer";
import FeedbackUs from "./FeedbackUs";
import api from "../../api";
import ContainerLoader from "../loader/container-loader";

function LearningLounge() {
  const [data, setData] = useState([]);
  const [isfetching, setIsfetching] = useState(false);

  const fetchData = async () => {
    try {
      setIsfetching(true);
      const request = {
        resource: "api/learningLounge",
        params: { pagetype: "viewer" },
      };
      const response = await api.learningLounge.getlearningLounge(request);
      let learningData = response.data.data.res;
      let filteredData = learningData.filter((record) => record?.isactive === true);
      setData(filteredData);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsfetching(false);
    }
  };

  function filterByMenuTypeId(alldata, menuTypeId) {
    return alldata.filter((item) => item.menu_type_id === menuTypeId);
  }

  useEffect(() => {
    fetchData();
  }, []);

  // common card style for reuse
  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "24px",
    height: "auto",
  };

  return (
    <div
      style={{
        minHeight: "820px",
        height: "auto",
        overflow: "auto",
        paddingTop: "8rem",
        paddingBottom: "1rem",
      }}
    >
      {isfetching ? (
        <div className="loaderMain">
          <ContainerLoader />
        </div>
      ) : (
        <>
          {/* First Row */}
        <Row className="mx-3">
  <MarqueeText data={filterByMenuTypeId(data, 1)} />

  {/* Access Our SPARK Program */}
  <Col xs={12} sm={12} md={6} lg={6} className="px-2 mb-3">
    <div className="card border light shadow sparkProgram" style={cardStyle}>
      <div className="quickLinksHeader ">
        Access Our SPARK Program
      </div>
      <ProgramsAvailable data={filterByMenuTypeId(data, 2)} />
    </div>
  </Col>

  {/* Gallery - HRD Captures */}
  <Col xs={12} sm={12} md={6} lg={6} className="px-2 mb-3">
    <div className="card border light shadow hrdCaptures" style={cardStyle}>
      <div className="quickLinksHeader">
        HRD Captures
      </div>
      <Gallery />
    </div>
  </Col>
</Row>


          {/* Quick Links Row - Full Width */}
          <Row className="mx-3">
            <Col
              xs={12}
              className="card border light shadow p-1"
              style={{
                backgroundColor: "#FFF",
                borderRadius: "24px",
                height: "auto",
                marginTop: "10px",
                padding: "1rem",
              }}
            >
              <div className="quickLinksHeader">Quick Links</div>
              <Row className="g-3 mx-0">
                {[4, 5, 6, 7, 8, 9].map((id, index) => (
                  <Col key={index} xs={12} sm={6} md={4} lg={2}>
                    <div className="quickLinksCard">
                      <QuickLinksCard data={filterByMenuTypeId(data, id)} />
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Knowledge */}
          <Row className="mx-2 mt-4">
            <Col xs={12} sm={12} md={6} lg={6} className="px-2 mb-3">
              <div className="card border light shadow p-1" style={cardStyle}>
                <KnowledgeNuggets playlist={filterByMenuTypeId(data, 10)} />
              </div>
            </Col>

            <Col xs={12} sm={12} md={6} lg={6} className="px-2 mb-3">
              <div className="card border light shadow p-1" style={cardStyle}>
                <VideoContainer playlist={filterByMenuTypeId(data, 11)} />
              </div>
            </Col>

            {/* Future Feedback card */}
            {/* <Col xs={12} sm={12} md={12} lg={4} className="px-2 mb-3">
              <div className="card border light shadow p-1" style={cardStyle}>
                <FeedbackUs />
              </div>
            </Col> */}
          </Row>
        </>
      )}
    </div>
  );
}

export default LearningLounge;
